module.exports = __webpack_public_path__ + "static/media/good_mood3ae59c03dcc1492d533f62d3bc4b0ffd.webp";